export default __webpack_public_path__ + "static/media/login-icon.77b714bb.svg";